'use client';

import { useRouter } from 'next/navigation';
import styles from './error.module.css';
import { useTranslations } from 'next-intl';

type Props = {
  message: string;
  showButton?: boolean;
  isFullHeight?: boolean;
  buttonAction?: 'refresh' | 'back';
};

export default function ErrorComponent({ message, showButton = true, isFullHeight = false, buttonAction = 'refresh' }: Props) {
  const router = useRouter();
  const t = useTranslations("Error");

  const handleClick = () => {
    if (buttonAction === 'back') {
      router.back();
    } else {
      router.refresh();
    }
  };

  return (
    <div className={styles.errorContainer} style={{ minHeight: isFullHeight ? '100vh' : 'auto' }}>
      <p className={styles.message}>{message}</p>

      {showButton && (
        <button className={styles.refreshButton} onClick={handleClick}>
          {buttonAction === 'back' ? t("backButton") : t("button")}
        </button>
      )}
    </div>
  );
}
